<template>
    <comHeader></comHeader>
          <!-- inner banner -->
    <div class="inner-banner">
        <section class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">About Us</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">Home</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>Privacy Policy</li>
                </ul>
            </div>
        </section>
    </div>
      <!-- //inner banner -->
    <section class="w3l-about-2 py-5">   
        <div class="container py-md-5 py-4">
            <div class="row align-items-center justify-content-between ">
            <!-- col-lg-6 about-2-secs-left pr-lg-5 -->
                <div style="width:100%;text-align: center;line-height: 100px">
                    <h1 class="title-style mb-sm-3 mb-2" >Website Consumer Business Privacy Statement</h1>
                </div>
                <p>
                    The website and its global affiliates (collectively referred to as the "Website", "we", "us", or "our") respect your privacy. We have prepared this Privacy Statement (hereinafter referred to as the "Statement") to help you understand how we collect, use, disclose, protect, store, and transfer your personal data. Please take a moment to read this Statement carefully. If you have any questions, please contact us.
                    This Statement applies to products and services that display or reference this Statement, including QR codes, software, toolkits, websites, and services.
                </p>
                <div class="about-2-secs-left pr-lg-5">
                    <h3 style="text-align:center">How the Website Collects and Uses Your Personal Data</h3>
                    <p>
                        Personal information refers to any kind of information, recorded electronically or otherwise, that is related to an identified or identifiable natural person, excluding anonymized information. When you use our products or services or interact with us, we may collect your personal data. The types of data collected will vary depending on the services you use and how you interact with us. In some cases, you may choose not to provide such data, but this may prevent us from providing certain services to you or responding to or resolving any issues you raise.
                    </p>
                    <h3 style="text-align:center">How the Website Protects Your Personal Data</h3>
                    <p class="w3l-grids-block-5 font-stle">
                        The security of your personal data is important to us. We use standard industry practices to protect your personal data from unauthorized access, disclosure, use, modification, damage, or loss. To achieve this, we take the following measures:
                        We use encryption technologies to ensure the confidentiality of data transmission and storage, and we implement trusted protection mechanisms to defend data and data storage servers against attacks.
                        We have deployed access control mechanisms to ensure that only authorized personnel can access your personal data.
                        We carefully select business partners and service providers, and incorporate personal data protection requirements into business contracts, audits, and evaluation activities.
                        We conduct security and privacy protection training sessions, tests, and awareness campaigns to enhance employees’ awareness of personal data protection.
                        We are fully committed to protecting your personal data. However, no security measures are perfect, and no product, service, website, data transmission, computer system, or network connection can be absolutely secure.
                        To address the potential risks of personal data leakage, damage, or loss, we have established various mechanisms and control measures, clearly defined security incident and vulnerability rating standards and corresponding handling procedures. We have also set up a dedicated security emergency response team responsible for implementing emergency plans, minimizing losses, conducting analysis, locating and repairing issues, and coordinating with relevant departments in accordance with security incident handling regulations and requirements.
                    </p>
                    <h3 style="text-align:center">Updates to This Statement</h3>
                    <p>
                        The Website reserves the right to update this Statement at any time. This Statement may be updated from time to time. For the latest version, please visit our official website. If there are significant changes to this Statement, we may notify you through various channels, such as posting a notice on our website or sending you a direct notification.
                    </p>
                    <h3 style="text-align:center">How to Contact Us</h3>
                    <p>
                        We have a department (or designated expert) dedicated to personal data protection. If you have any questions, comments, or suggestions, please contact us via customer service. Generally, we will provide an initial response within three business days.
                    </p>
                </div>
            </div>
            <div>
                <p>
                    © All rights reserved by the Website.
                    Last Updated: February 8, 2025
                </p>
            </div>
        </div>
    </section>
</template>

<script>
import comHeader from '../components/comHeader.vue';
export default{
    name: 'appPolicy',
    components:{
        comHeader
    }
}
</script>

<style>
</style>